import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-side-navigation-submenu-redaction',
  templateUrl: './side-navigation-submenu-redaction.component.html',
  styleUrls: ['./side-navigation-submenu-redaction.component.scss']
})
export class SideNavigationSubmenuRedactionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
